<mat-form-field appearance="fill" [formGroup]="textForm">
    <mat-label>{{label}}</mat-label>
    <input matInput placeholder={{placeholder}} formControlName="mytext" >
</mat-form-field>